import { useHistory, useLocation } from "react-router-dom";
import qs from "qs";

export interface IMultiple {
  remove: string;
  set: object;
}

const useQueryParams = () => {
  const history = useHistory();
  const location = useLocation();

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true });
  // 2026-09-14 (tog'a #2025): o'zgartiruvchi chaqiruvlar joriy URL ni YANGIDAN o'qiydi — ketma-ket removeMany + set bir-birini o'chirmasin
  const current = () => qs.parse(history.location.search, { ignoreQueryPrefix: true });
  const set = (key: string, value: string) =>
    history.push({ search: qs.stringify({ ...current(), [key]: value }) });

  const setObj = (key: string, value: object) =>
    history.push({ search: qs.stringify({ ...current(), [key]: value }) });
  const clear = () => history.push({ search: qs.stringify({}) });

  const append = (values: object) =>
    history.push({ search: qs.stringify({ ...current(), ...values }) });

  const remove = (key: string) => {
    let newParams = { ...current() };
    if (newParams[key]) {
      delete newParams[key];
    }

    history.push({ search: qs.stringify(newParams) });
  };
  const multiple = ({ remove, set }: IMultiple) => {
    let newParams = { ...current() };
    const items = remove.split(",");
    items.forEach((k) => {
      if (newParams[k]) {
        delete newParams[k];
      }
    });

    newParams = { ...newParams, ...set };
    // tog'a #257 (2026-10-20): filtrda tozalangan maydon ("" / null) — URL dan olib tashlanadi (avval «warehouseId=» qolib ketardi)
    Object.entries(set).forEach(([k, v]) => {
      if (v === "" || v === null) delete (newParams as any)[k];
    });

    history.push({
      search: qs.stringify(remove.includes("*") ? set : newParams),
    });
  };
  const removeMany = (...values: string[]) => {
    let newParams = { ...current() };
    values.forEach((k) => {
      if (newParams[k] !== undefined) {
        delete newParams[k];
      }
    });

    history.push({ search: qs.stringify(newParams) });
  };

  const has = (key: string) => !!queryParams[key];
  const get = (key: string) => queryParams[key];
  const secureGet = (key: string) => queryParams[key] || "";
  const goBack = () => history.goBack();

  return {
    values: queryParams,
    set,
    remove,
    clear,
    append,
    has,
    get,
    goBack,
    multiple,
    secureGet,
    removeMany,
    setObj,
  };
};

export default useQueryParams;
